import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewEncapsulation,
} from '@angular/core';
import { FnGridColumn } from './../../../model/fn-grid-column';

@Component({
	selector: 'fn-grid-header-filter',
	templateUrl: './fn-grid-header-filter.component.html',
	styleUrls: ['./fn-grid-header-filter.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class FnGridHeaderFilterComponent {
	constructor() {}
	isTextActive = true;
	@Input() column: FnGridColumn;
	@Output() callback = new EventEmitter<any>();
}
